module.exports = __webpack_public_path__ + "static/media/support.c75f66ca.png";